import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import { AccountModal, SettingsModal } from '@/lazy-load-components';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';

import { useLanguageStore, useRoutingStore, useUserStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper-vfm';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginMenuButtonNew',
  props: {
    dark: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { dark: boolean };



const { loginProgress, isLoggedIn, setLoginProgress, isUserOnboarded } = useUserStore();
const { activeRoute } = useRoutingStore();
const { country } = useLanguageStore();
const isLightTheme = computed(() => {
	return false;
	//return country.value === 'GB' && activeRoute.value.path === '/' && !isUserOnboarded.value;
});

const color = computed(() => {
	if (isLightTheme.value) {
		return 'ghost';
	}
	return props.dark ? 'dark' : 'primary';
});

function handleAccountClick() {
	ModalHelper.openModal(SettingsModal);
}

function handleLoginClick() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () => {
		setLoginProgress(true);
	});
}

return { __sfc: true,props, loginProgress, isLoggedIn, setLoginProgress, isUserOnboarded, activeRoute, country, isLightTheme, color, handleAccountClick, handleLoginClick, BasicButton, faUserCog }
}

})